import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Switch from "react-switch";
import { handleFunction } from "./handleFunction";

const Toggle = ({ setDefaultValues, removeDefaultValues, retryCheck }) => {
  const [state, setState] = useState({
    checked: false,
  });

  useEffect(() => {
    if (retryCheck) {
      setState({
        checked: false,
      });
      removeDefaultValues();
    }
  },
  // eslint-disable-next-line
  [retryCheck, removeDefaultValues]);

  const handleChange = handleFunction(setState, state, setDefaultValues, removeDefaultValues);

  return (
    <label htmlFor="normal-switch">
      <Switch
        onChange={handleChange}
        checked={state.checked}
        uncheckedIcon={false}
        checkedIcon={false}
        width={35}
        height={16}
        handleDiameter={22}
        offColor={"#B1B9B7"}
        onColor={"#85BAAC"}
        offHandleColor={"#ffffff"}
        onHandleColor={"#087558"}
        activeBoxShadow={"#fff"}
        id="normal-switch"
      />
    </label>
  );
};

Toggle.propTypes = {
  removeDefaultValues: PropTypes.func,
  retryCheck: PropTypes.bool,
  setDefaultValues: PropTypes.func,
};

export default Toggle;


